import './smooth-scolling';
import MobileMenu from "./components/MobileMenu";
import DonateForm from "./components/DonateForm";

(function() {
    new MobileMenu();
    new DonateForm();
})();
